<template>
  <!-- dashboard-area start -->
  <div class="dashboard-area pt-30" id="topo">
    <div class="container cardspadding" style="max-width: 1170px;">
      <div class="col-12 cardspadding">
        <div class="pannel-wrapper white-bg mb-60">
          <div class="col-sm-12 mb-5 cardspadding">
            <img src="https://www.lefisc.com.br/monitoramentoncm/img/banner5.png" style="width:100%" />
          </div>
          <div class="container ">
            <div class="row counter-box">
              <div class="col-lg-3 col-md-6">
                <monitoramento-comp :contador="contador" />
              </div>
              <div class="col-lg-9 col-md-6 borda-esq">
                <div class="pannel-wrapper white-bg">
                  <div class="panel-heading heading-border">
                    <h4 class="m-0">Filtre suas NCMs</h4>
                  </div>
                  <div class="panel-body">
                    <div class="row">
                      <div class="col-md-12 cardspadding" style="text-align:right">
                        <div>
                          <b-form-input
                            v-model="filtroNCM"
                            placeholder="Filtre por NCM ou Descrição"
                          ></b-form-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body mt-3 pt-0" style="padding:35px">
            <div class="mb-3">
              <h6 class="fw-bold">NCMs Monitoradas</h6>
            </div>
            <div class="text-center" v-if="loading">
              <div class="spinner-border loading text-primary mt-5 mb-5 text-center" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>

            <transition name="exibir">
              <div v-if="!loading">
                <!-- IMAGEM DE ALERTA CASO NÃO TENHA MONITORADAS -->
                <div
                  v-if="monitoradas.length == 0"
                  class="col-sm-12 mb-3 center"
                  style="padding:0px; text-align:center;"
                >
                <i class="material-icons" style="font-size:148px;color:#ff4d4d">warning</i>
                </div>
                <div v-for="item in ncmsFiltradas" :key="item.ncm">
                  <card
                    :monitorada="item"
                    class="efeitoHover"
                    @excluirmonitorada="atualizarLista"
                    v-if="item"
                  />
                </div>
                <div class="text-center" v-if="loadingMaisPost">
                  <div class="spinner-border text-primary mt-5 mb-5 text-center" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            </transition>

            <!-- Botão Subir -->
            <transition name="exibir">
              <i class="fa fa-2x fa-arrow-circle-up icone" 
              v-scroll-to="'#topo'"
              v-if="subir">
              </i>
            </transition>
            <!-- Botão Subir FIM -->


            <p class="text-center" v-if="filtroNCM && ncmsFiltradas.length == 0 && !loading">
              <span>Sua busca não encontrou nenhum resultado</span>
            </p>
            <p class="text-center" v-if="mensagemFim">Não há mais NCMs a serem carregadas</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- dashboard-area end -->
</template>

<script>
import serviceHome from "../services/ServiceHome";
import serviceMonitoradas from "../services/ServiceMonitoradas";
import serviceCookie from "../services/ServiceCookie";
import serviceMonitoramentoCompo from "../services/ServiceMonitoramentoComp";
import monitoramentoComp from "../components/monitoramento/monitoramento_comp";
import { routes } from "../routes/index";
import card from "../shared/cardMonitoradas";
import { setTimeout } from "timers";
import { log } from "util";

export default {
  components: {
    card,
    "monitoramento-comp": monitoramentoComp
  },
  data() {
    return {
      Ordenar: "Ordenar por ",
      usuario: "",
      routes: routes,
      filtroNCM: "",
      encontrado: false,
      monitoradas: [],
      loading: true,
      loadingMaisPost: false,
      finalDaPagina: false,
      subir: false,
      contador: "",
      iniciado: false,
      nPage: 1,
      qPage: 15,
      mensagemFim: false,
    };
  },

  async created() {
    this.usuario = await serviceCookie.getCookie("idCliente");
    if (this.usuario.length > 0) {
      //this.usuario = this.usuario.substring(3);
      this.usuario = parseInt(this.usuario);
      if (!this.usuario) this.usuario = 0;
    }

    //pegando numero de monitoradas
    await serviceHome.getContadorNCMs(this.usuario).then(
      res => {
        if (res < 10) this.contador = "0" + res;
        else this.contador = res;
      },
      err => {
        console.error(err);
      }
    );
    this.carregaPostagem(true);
  },

  mounted() {
    this.scroll();
  },

  computed: {
    ncmsFiltradas() {
      if (this.filtroNCM) {
        let exp = new RegExp(this.filtroNCM.trim(), "i");
        return this.monitoradas.filter(
          monitorada =>
            exp.test(monitorada.descricao) || exp.test(monitorada.ncm)
        );
      } else {
        return this.monitoradas;
      }
    },
  },

  methods: {
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          Math.max(
            window.pageYOffset,
            document.documentElement.scrollTop,
            document.body.scrollTop
          ) +
            window.innerHeight >=
          document.documentElement.offsetHeight;

        this.botaoTopo(document.documentElement.scrollTop);

        if (bottomOfWindow && !this.mensagemFim) {
          this.finalDaPagina = true;
          
          this.carregaPostagem();
        } else this.finalDaPagina = false;
      };
    },

    botaoTopo(valor) {      
      if (valor > 500) this.subir = true;
      else this.subir = false;
    },

    async carregaInicio () {
      await serviceMonitoradas.getMonitoradas(this.nPage, this.qPage, this.usuario).then(
        res => {
          if (inicio) this.loading = false;
          else this.loadingMaisPost = false;
          
          if (res != "NCM não encontrada!" || res != '') {
            let arrayTemp = '';
            this.monitoradas = res;
            this.nPage += 1;
            this.onscroll();
          }else {
            this.mensagemFim = true;
          }
        },
        err => {
          console.error(err);
          this.loading = false;
          this.loadingMaisPost = false;
        }
      )
    },

    async carregaPostagem(inicio) {
      //pegando monitoradas
      if (!this.loadingMaisPost) {
        this.loadingMaisPost = true;
        await serviceMonitoradas.getMonitoradas(this.nPage, this.qPage, this.usuario).then(
          res => {
            this.loading = false;
            this.loadingMaisPost = false;
            
            if (res != "NCM não encontrada!" || res != '') {
              let arrayTemp = '';
              try {
                res.forEach(item => {
                  this.monitoradas.push(item);
                });
                this.nPage += 1;
              } catch {
                this.mensagemFim = true;
                this.nPage += 1;
              }
            }else {
              this.mensagemFim = true;
            }
            this.iniciado = true;
          },
          err => {
            console.error(err);
            this.loading = false;
            this.loadingMaisPost = false;
            this.mensagemFim = true;
            this.iniciado = true;
          }
        )
      }
      
    },

    atualizarLista(ncm) {
      if (this.monitoradas.length > 0) {
        for (let i = 0; i < this.monitoradas.length; i++) {
          if (this.monitoradas[i].ncm == ncm) {
            this.monitoradas.splice(i, 1);
            this.contador -= 1;
            if (this.contador < 10) this.contador = "0" + this.contador;
          }
        }
      } else {
        setTimeout(() => {
          this.$router.push({ name: "Início" });
        }, 100);
      }
    }
  }
};
</script>

<style scoped>
.fw-bold {
  font-weight: bold;
}

.icone {
  position: fixed;
  right: 50px;
  bottom: 115px;
  background-color: #ddd;
  padding: 10px;
  border-radius: 5px;
  color: white;
}

.iconeContent {
  height: 100px;
  width: 100px;
}

.warning {
  border: 3px solid #ffd950;
  border-radius: 100%;
  width: 100px;
  height: 100px;
  font-size: 60px;
  color: #ffd950;
  line-height: 100px;
}

.titulo {
  font-size: 20px;
  text-align: center;
  font-weight: bold;
  margin-top: 20px;
}

.alerta {
  font-size: 12px;
  margin-top: 10px;
}

.loading {
  height: 100px;
  width: 100px;
  font-size: 30px;
}

.exibir-enter,
.exibir-leave-to {
  opacity: 0;
}

.exibir-enter-to,
.exibir-leave {
  opacity: 1;
}

.exibir-leave-active,
.exibir-enter-active {
  transition: all 0.5s;
}

.efeitoHover:hover {
  cursor: pointer;
}

.borda-esq {
  border-left: 1px solid #ddd;
}

.panel-heading {
  padding: 20px 0;
}

.cardspadding {
  padding: 0px;
}
</style>